import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { get } from 'lodash';
import classNames from 'classnames';

import { linksWithQuery } from '[theme-lib]/links';
import { msg } from 'lib/api';

const FAVOURITES_URL = linksWithQuery.SHOW_FAVOURITES({ from: 'nav' });

export default function PersonalSection({
  isSuggestedOrderAvailable, hideSection, onLeafItemMouseOver, onItemMouseClick,
}) {
  const personalSectionClass = classNames('base-level', 'personal-section', { hidden: hideSection });
  const pricePromiseUrl = get(msg, 'nav.urls.pricePromise');
  const pricePromiseLabel = get(msg, 'nav.labels.pricePromise');

  return (
    <div className={personalSectionClass}>
      <ul>
        {(pricePromiseUrl && pricePromiseLabel) && (
          <li className="level-item price-promise leaf">
            <Link
              className="level-item-link"
              to={pricePromiseUrl}
              onFocus={onLeafItemMouseOver}
              onMouseOver={onLeafItemMouseOver}
              onClick={onItemMouseClick}
            >
              {pricePromiseLabel}
            </Link>
          </li>
        )}
        {isSuggestedOrderAvailable && (
          <li className="level-item instant-shop leaf">
            <Link
              className="level-item-link"
              to="/webshop/displaySuggestedOrder.do?from=nav"
              onFocus={onLeafItemMouseOver}
              onMouseOver={onLeafItemMouseOver}
              onClick={onItemMouseClick}
            >
              Instant Shop
            </Link>
          </li>
        )}
        <li className="level-item personal-favourites leaf">
          <Link
            className="level-item-link"
            to={FAVOURITES_URL}
            onFocus={onLeafItemMouseOver}
            onMouseOver={onLeafItemMouseOver}
            onClick={onItemMouseClick}
          >
            Favourites
          </Link>
        </li>
        <li className="level-item personal-orders leaf">
          <Link
            className="level-item-link"
            to="/webshop/displayAllOrders.do?from=nav"
            onFocus={onLeafItemMouseOver}
            onMouseOver={onLeafItemMouseOver}
            onClick={onItemMouseClick}
          >
            Orders
          </Link>
        </li>
      </ul>
    </div>
  );
}

PersonalSection.propTypes = {
  isSuggestedOrderAvailable: PropTypes.bool,
  hideSection: PropTypes.bool,
  onLeafItemMouseOver: PropTypes.func.isRequired,
  onItemMouseClick: PropTypes.func.isRequired,
};
